import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import UserNavBar from "../../Components/Common/UserNavBar";
import UserFooter from "../../Components/Common/UserFooter";
import ScrollToTop from "./ScrollToTop";
import MobileBottomNav from "../../Components/Common/MobileBottomNav";
import { useAuth } from "../../Components/Context/AuthContext";

const UserLayout = (props) => {
  const { isAuthenticated } = useAuth()
  const location = useLocation();
  const [showNav, setShowNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const hideFooterRoutes = [
    "/orders",
    "/returns",
    "/supplier-returned-orders",
    "/post-requirement",
    "/post-order-via-offer",
    "/wallet",
    "/products",
    "/quotations",
    "/account",
    "/supplier-orders",
    "/supplier-quotations",
    "/create-quotation",
    "/supplier-quotation-details",
    "/supplier-rqm-requests",
    "/post-rqm-request",
    "/supplier-linked-varieties",
    "/supplier-penalties",
    "/buyer-penalties",
  ];
  const shouldHideFooter = hideFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );
  const shouldShowMobileNav = ['/post-requirement', '/supplier-quotations', '/create-quotation'].some((route) =>
    location.pathname.startsWith(route));

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 50) {
        setShowNav(true);
      } else if (currentScrollY > lastScrollY) {
        setShowNav(false); // scrolling down → hide
      } else {
        setShowNav(true); // scrolling up → show
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <React.Fragment>
      <ScrollToTop />
      <UserNavBar showNav={showNav} />
      <div className={isAuthenticated ? "pt-[3.2rem] md:pt-[3rem]" : "pt-[5.2rem] md:pt-[4.8rem]"}>
        {props.children}
      </div>
      {!shouldHideFooter && <UserFooter />}
      {!shouldShowMobileNav && isAuthenticated && <MobileBottomNav />}
    </React.Fragment>
  );
};

export default UserLayout;

// const MessageButton = () => {
//   const openMessageModal = () => {
//     const phoneNumber = "919393991563";
//     const whatsappUrl = `https://wa.me/${phoneNumber}`;
//     window.open(whatsappUrl, "_blank");
//   };

//   return (
//     <button
//       className="fixed right-4 bottom-4 p-2 bg-[#f5e7e7] rounded-full shadow-lg hover:bg-[#f8bdbd] hover:scale-105 ease-in-out duration-300 focus:outline-none transition-transform transform-gpu"
//       onClick={openMessageModal}
//     >
//       <FaWhatsapp size={32} color="#10b416" />
//     </button>
//   );
// };
